import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ACCOUNT_TYPE } from '_constants';
import { TableHeader } from 'components/organisms';
import { NewMessageModal } from 'components/organisms/modals';
import { MessageTemplate } from 'components/templates';
import React, { useMemo, useState } from 'react';

import { Therapist } from '../_api/types';
import { useUser } from '../utils/hooks';

export const MessageView = () => {
  const [open, setOpen] = useState(false);
  const { account } = useUser();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const showMessages = useMemo(() => {
    if (account && account.accountType == ACCOUNT_TYPE.THERAPIST) {
      return (account as Therapist).hospital.canGuardianContactTherapist != false;
    }
    return false;
  }, [account]);

  const height = useMemo(() => {
    if (isXs) return '60vh';
    if (isSm) return '65vh';
    if (isMd) return '70vh';
    return '75vh';
  }, [isXs, isSm, isMd]);

  return showMessages ? (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        width: '75%',
        height: `${height}`,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
          width: '100%',
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left', p: 2 }}>
          Messages
        </Typography>
        <TableHeader onAddClick={() => setOpen(true)} hideSearch={true} />
      </Box>
      <MessageTemplate />
      <NewMessageModal open={open} onClose={() => setOpen(false)} />
    </Container>
  ) : (
    <Container
      component="main"
      maxWidth="xl"
      sx={{
        width: '75%',
        height: `${height}`,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
          width: '100%',
        }}
      >
        <Box>
          <Typography variant={'h4'} sx={{ textAlign: 'center', paddingBottom: '20px' }}>
            Messaging Not Available
          </Typography>
          <Typography variant={'h5'} sx={{ textAlign: 'left' }}>
            Messaging is not available for this organization. Please contact your hospital
            administrator with any questions
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};
